import React, { useEffect, useState } from "react";
import { Box, Button, MenuItem, TextField } from "@material-ui/core";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { ExtLeague, ExtLeagueFilter, ExtLeagueMapping, MapLeagueRequest, Sport } from "./LeagueModels";
import LeagueUtil from "./LeagueUtil";
import ExtLeagueTable from "./ExtLeagueTable";
import { bool } from "prop-types";
import { BaseItemState } from "../Ticker2/Ticker2Models";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import { act } from "react-dom/test-utils";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";
import FixtureOverviewUtil from "../FixtureOverview/FixtureOverviewUtil";
import { ActionState } from "../FixtureOverview/FixtureOverviewModels";
import { UpdateItemState } from "../CreateSyndicate/CreateSyndicateModels";
import { blue } from "@material-ui/core/colors";
import ConfirmationDialog from "../Components/ConfirmationDialog";
import ProviderSelect from "./ProviderSelect";
import SportSelect from "./SportSelect";
import MappedFilterSelect from "./MappedFilterSelect";
import Ticker2Util from "../Ticker2/Ticker2Util";

interface ExtLeagueViewState {
    // leagueId: number;
    // leagueName: string;
    providerId: string;
    sportId: number;
    country: string;
    competition: string;
    mapped?: boolean;
    valid: boolean;
    providerIdError: string;
    sportIdError: string;
    countryError: string;
    competitionError: string;
    // extLeagues: ExtLeague[];
    // refreshing: boolean;
}
interface ExtLeagueItemState extends BaseItemState<ExtLeague, number> {
    leagueId: number;
}
interface MapLeagueState extends UpdateItemState<ExtLeague> {
    leagueId: number;
    leagueName: string;
}
interface ExtLeagueViewProps {
    leagueId: number;
    leagueName: string;
}
const ExtLeagueView: React.FC<ExtLeagueViewProps> = (props) => {
    const [formState, setFormState] = useState<ExtLeagueViewState>({
        // leagueId: 0,
        // leagueName: "",
        providerId: "",
        sportId: 0,
        country: "",
        competition: "",
        valid: true,
        providerIdError: "",
        sportIdError: "",
        countryError: "",
        competitionError: "",
        // extLeagues: [],
        // refreshing: true
    });
    const [itemState, setItemState] = useState<ExtLeagueItemState>({
        leagueId: props.leagueId,
        items: [],
        more: false,
        lastId: 0,
        refreshing: false

    });
    const [selectedItem, setSelectedItem] = useState<ExtLeague | undefined>(undefined);
    const [actionState, setActionState] = useState<ActionState>(FixtureOverviewUtil.createEmptyActionState());
    const [mapLeagueState, setMapLeagueState] = useState<MapLeagueState>({
        method: 'none',
        item: undefined,
        handled: false,
        updateNo: 0,
        version: 0,
        leagueId: 0,
        leagueName: ""
    });
    const history = useHistory();   

    useEffect(() => {
        refreshItems("Init");
    }, []);

    const refreshItems = (caller: string) => {
        if (itemState.refreshing) {
            return;
        }
        if (!formState.valid) {
            return;
        }
        var rs : ExtLeagueItemState = {
            leagueId: props.leagueId,
            items: [],
            more: false,
            lastId: 0,
            refreshing: false
        }
        var ast = FixtureOverviewUtil.createEmptyActionState();
        var lastId = caller === "onMore" ? itemState.lastId : 0;
        if (lastId > 0) {
            rs.items = itemState.items;
        }
        var success = false;
        itemState.refreshing = true;
        //const sportId = 1;
        setActionState(FixtureOverviewUtil.createActionState(true, false, `RefreshItems(${caller})...`));
        var filter : ExtLeagueFilter = {
            sportId: formState.sportId,
            providerId: formState.providerId,
            competition: formState.competition,
            country: formState.country,
            mapped: formState.mapped
        }
        LeagueUtil.getExtLeagues(100, lastId, filter).then( resp => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `RefreshItems(${caller}) error: ${resp.message}`;
                return;
            }
            var listResponse = resp.item;
            if (listResponse) {
                if (listResponse.items) {
                    if (lastId > 0) {
                        for (const item of listResponse.items) {
                            rs.items.push(item);
                        }
                    } else {
                        rs.items = listResponse.items;
                    }
                    if (listResponse.items.length > 0) {
                        rs.lastId = listResponse.items[listResponse.items.length - 1].id;
                    }
                    if (listResponse.pageSize <= listResponse.items.length) {
                        rs.more = true;
                    }
                }           
            }
            success = true;
        }).catch( error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, `RefreshItems(${caller}) error`);
        }).finally( () => {
            if (success || lastId <= 0) {
                setItemState(rs);
            }
            itemState.refreshing = false;
            setActionState(ast);
        });
    };
    const onRefreshExtLeagues = () => {
        refreshItems("Refresh");
    };
    const onMore = () : void => {
        if (itemState.lastId <= 0) {
            setActionState(FixtureOverviewUtil.createActionState(true, false, "More failure: LastId was not set."));
            return;
        }
        refreshItems("onMore");
    }
    const unmapLeague = (item: ExtLeague) => {
        if (item.mappingId === undefined || item.mappingId <= 0) {
            setActionState(FixtureOverviewUtil.createActionState(true, false, `Unmap league failure: Ext league '${item.name}' is not mapped.`));
            return;
        }
        var ast = FixtureOverviewUtil.createEmptyActionState(); 
        setActionState(FixtureOverviewUtil.createActionState(true, false, "Unmapping league..."));
        var finished = false;
        LeagueUtil.unmapLeague(item.mappingId).then((resp) => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `Unmap League error: ${resp.message}`;
                return;
            }
            // var extMapping : ExtLeagueMapping = {...item.mapping, id: 0 };
            //var extLeague = {... item, mapping: extMapping};
            var extLeague = {... item, mapping: null};
            extLeague.mappingId = 0;
            extLeague.mappingStatus = "";
            extLeague.leagueId = 0;
            extLeague.leagueName = "";
            var extLeagueIndex = itemState.items.findIndex(it => it.extId === item.extId);
            if (extLeagueIndex >= 0) {
                itemState.items[extLeagueIndex] = extLeague;
                setSelectedItem(extLeague);
            }
        }).catch(error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, "Unmap League error");
        }).finally(() => {
            setActionState(ast);
        });
    };

    const onMap = () => {
        if (props.leagueId <= 0) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "League is not selected."));
            return;
        }
        if (!selectedItem) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Ext league is not selected."));
            return;
        }
        if (selectedItem.mappingId && selectedItem.mappingId > 0) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Ext league is already mapped."));
            return;
        }
        var request : MapLeagueRequest = {
            providerId: selectedItem.providerId,
            leagueId: props.leagueId,
            extCompetitionId: selectedItem.extId,
            extCompetitionName: selectedItem.name
        };
        var ast = FixtureOverviewUtil.createEmptyActionState();
        
        var sportId = 2; //Football
        setActionState(FixtureOverviewUtil.createActionState(true, false, `Mapping league...`));
        //formState.refreshing = true;
        LeagueUtil.mapExtLeague(request).then((resp) => {
            if (!resp.success) {
                ast.error = true;
                ast.message = `Unmap League error: ${resp.message}`;
                return;
            }
            if (!resp.item) {
                return;
            }
            var item = resp.item;
            // selectedItem.mapping = { 
            //     id: item.id,
            //     leagueId: item.leagueId,
            //     leagueName: item.leagueName
            // };
            // selectedItem.mappingId = item.id;
            // selectedItem.leagueId = item.leagueId;
            // selectedItem.leagueName = item.leagueName;
            // selectedItem.mappingStatus = "REGISTERED";
            var extLeagueIndex = itemState.items.findIndex(it => it.id === item.id);
            // if (extLeagueIndex >= 0) {
            //     var ist = {...itemState, refreshing: false };
            //     ist.items[extLeagueIndex] = item;
            //     setItemState(ist);
            // }
            // setSelectedItem(item);
            if (extLeagueIndex >= 0) {
                itemState.items[extLeagueIndex] = item;
                // if (selectedItem && selectedItem.extId === extFixture.extId) {
                    setSelectedItem(item);
                // }
            } else {
                if (selectedItem) {
                    setSelectedItem(undefined);
                }
            }
            }).catch(error => {
            ast.error = true;
            ast.message = CreateRoundUtil.getExceptionMessage(error, false, "Map League error");
        }).finally(() => {
            setActionState(ast);
        });
    };
    const onMapItem = (item: ExtLeague) => {
        if (!item) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Ext league is not selected."));
            return;
        }
        if (!item.leagueId) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Ext league is not mapped to league."));
            return;
        }
        var mapping = item.mapping;
        if (!mapping) {
            setActionState(FixtureOverviewUtil.createActionState(false, true, "Ext league is not mapped to league."));
            return;

        }
        // if (item.mappingId && item.mappingId > 0) {
        //     setAction(FixtureOverviewUtil.createActionState(false, true, "Ext fixture is already mapped."));
        //     return;
        // }
        setMapLeagueState({
            method: (item.mappingId && item.mappingId > 0) ? 'remove' : 'add',
            item: item,
            handled: false,
            updateNo: 0,
            version: 0,
            leagueId: 0,
            leagueName: ""
        });

    };
    const checkState = (fs: ExtLeagueViewState) => {
        var valid = true;
        var providerIdErr = "";
        var sportIdErr = "";
        var countryErr = "";
        var competitionErr = "";
        // if (!fs.providerId || fs.providerId.length <= 0) {
        //  valid = false;
        //  providerIdErr = "Required";
        // }
        // if (fs.sportId  <= 0) {
        //     valid = false;
        //     sportIdErr = "Required";
        // }
        fs.valid = valid;
        fs.providerIdError = providerIdErr;
        fs.sportIdError = sportIdErr;
        fs.countryError = countryErr;
        fs.competitionError = competitionErr;
     };
     const onChangeState = (fs: ExtLeagueViewState) => {
    //    var ist : ExtLeagueItemState = {
    //         leagueId: props.leagueId,
    //         items: [],
    //         more: false,
    //         lastId: "",
    //         refreshing: false
    //     }
        checkState(fs);
        setFormState(fs);
        // setItemState(ist);
        // setSelectedItem(undefined);
    };
     const onChangeProviderId = (providerIdX?: string) => {
        var providerId = providerIdX ? providerIdX : "";
       if (providerId === formState.providerId) {
        return;
       }
       var fs = {...formState, providerId: providerId};
       onChangeState(fs);
    };
    const onChangeSportId = (sport?: Sport) => {
        var sportId = sport ? sport.id : 0;
       if (sportId === formState.sportId) {
        return;
       }
       var fs = {...formState, sportId: sportId};
       onChangeState(fs);
    };
    const onChangeMapped = (mapped?: boolean) => {
        if (mapped === formState.mapped) {
            return;
        }
        var fs = {...formState, mapped: mapped};
        onChangeState(fs);
    };
    const onChange = (name: string, value: any) => {
       var fs = {...formState,  [name]: value};
       onChangeState(fs);
    };
    const onSelect = (item : ExtLeague) => {
        setSelectedItem(item);
    };
    const onUnmapLeagueClose = (confirmed: boolean | undefined) : void => {
        if (mapLeagueState.handled) {
            return;
        }
        var ms = {...mapLeagueState, handled: true};
        setMapLeagueState(ms);
        if (!confirmed || !ms.item) {
            return;
        }
        unmapLeague(ms.item);      
    };
    
    var isExecuting = itemState.refreshing || actionState.executing;
    var extLeagues = itemState.items;
    if (itemState.leagueId !== props.leagueId){
        itemState.leagueId = props.leagueId;
        itemState.items = [];
        refreshItems("ChangeLeague");
    }
    // var leagueInfo = "League - Not selected";
    // if (props.leagueId > 0) {
    //     leagueInfo = `League - Id:${props.leagueId} | Name: ${props.leagueName}`;
    // }
    var extLeagueInfo = "Ext league - Not selected";
    if (selectedItem) {
        extLeagueInfo = `Ext league - Id:${selectedItem.extId} | Name: ${selectedItem.name} | Country: ${selectedItem.countryName} | Mapping Id: ${selectedItem.mappingId ? selectedItem.mappingId.toString() : ""}`;
    }
    var actionBox = null;
    if ((actionState.executing || actionState.error) && actionState.message.length > 0) {
        actionBox = (
            <Box color={actionState.error ? RoundOverviewUtil.INVALID_COLOR : blue[500]} fontSize={12}>
                {actionState.message}
            </Box>
        );
    }
    var mapEnabled = (props.leagueId > 0 && selectedItem && !selectedItem.mapping);
    //var providerIds = LeagueUtil.getProviderIds();

    var mapDialog = null;
    if (mapLeagueState.item && !mapLeagueState.handled) {
        if (mapLeagueState.method === "remove") {
            var mapItem = mapLeagueState.item;
            const unmapContent = (
                <Box>
                    Please confirm that you want to unmap league <br/>'<b>{mapItem.leagueName}</b>' <br/>with external<br/>
                    '<b>{mapItem.name}</b>'<br/>at provider<br/><b>{formState.providerId}</b><br/>with mapping id<br/><b>{mapItem.mappingId}</b> .
                </Box>
            );
            mapDialog = (
                <ConfirmationDialog open={true} title="Unmap league" message="Please confirm that you want to unmap league." messageElement={unmapContent} onClose={onUnmapLeagueClose} />
            );            
        }
    }

    var info = Ticker2Util.toItemStateString(itemState);
    var moreBtn = null;
    if (itemState.more && !itemState.refreshing) {
        moreBtn = (<Button 
            variant="text"
            color="secondary"
            size="small"
            disabled={itemState.refreshing}
            onClick={e => onMore()}>
            More
        </Button>);
    }

    return (
        <div>
            {/* <Box fontSize={10}>
                {leagueInfo}
            </Box> */}
                <ProviderSelect value={formState.providerId} onChange={onChangeProviderId} allItemEnabled={true} error={formState.providerIdError.length > 0} helperText={formState.providerIdError} />
                <SportSelect value={formState.sportId} onChange={onChangeSportId} allItemEnabled={true} error={formState.sportIdError.length > 0} helperText={formState.sportIdError} />
                <Box fontSize={10} marginTop={2}>
                <TextField
                    label="Country"
                    name="country"
                    value={formState.country}
                    onChange={e => onChange("country", e.target.value)}
                    style={{ marginRight:"5px"}}
                    error={formState.countryError.length > 0}
                    helperText={formState.countryError}
                />
                <TextField
                    label="Competition"
                    name="competition"
                    value={formState.competition}
                    onChange={e => onChange("competition", e.target.value)}
                    style={{ marginRight:"5px"}}
                    error={formState.competitionError.length > 0}
                    helperText={formState.competitionError}
                />
                <MappedFilterSelect value={formState.mapped} onChange={onChangeMapped}/>
                <Button 
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={isExecuting || !formState.valid}
                    style={{marginRight: "5px"}}
                    onClick={e => onRefreshExtLeagues()}>
                    Search
                </Button>
            </Box>
            <Box fontSize={10} marginTop={2}>
                {extLeagueInfo}
            </Box>
            <Box>
                <Button 
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={isExecuting || !mapEnabled}
                    style={{marginRight: "5px"}}
                    onClick={e => onMap()}>
                    Map
                </Button>
            </Box>
            {actionBox}
            <Box fontSize={10}>
                {info}{moreBtn}
            </Box>
            <ExtLeagueTable items={extLeagues} onSelect={onSelect} onMap={onMapItem} />
            {mapDialog}
            {/* <Box>
                <pre>{JSON.stringify(formState, undefined, 2)}</pre>
            </Box> */}
        </div>
    );
};

export default ExtLeagueView;

